import { render, staticRenderFns } from "./NotorietyDisplay.vue?vue&type=template&id=b9564334&"
import script from "./NotorietyDisplay.vue?vue&type=script&lang=js&"
export * from "./NotorietyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports